<template>
  <Breadcrumbs title="pageTitle" />
  <Card1
    colClass="col-sm-12"
    cardhaderClass="pb-0 title-header"
    title="Create Workspace Module"
  >
    <br />
    <br />
    <br />
    <div class="horizontal-wizard-wrapper vertical-options vertical-variations">
      <div class="row g-3">
        <div class="col-xl-3 main-horizontal-header">
          <div
            class="nav nav-pills horizontal-options"
            id="vertical-n-wizard-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link active"
              id="wizard-n-info-tab"
              data-bs-toggle="pill"
              href="#wizard-n-info"
              role="tab"
              aria-controls="wizard-n-info"
              aria-selected="true"
            >
              <div class="horizontal-wizard">
                <div class="stroke-icon-wizard"><span>1</span></div>
                <div class="horizontal-wizard-content">
                  <h3>Module</h3>
                </div>
              </div> </a
            ><a
              class="nav-link"
              id="bank-n-wizard-tab"
              data-bs-toggle="pill"
              href="#bank-n-wizard"
              role="tab"
              aria-controls="bank-n-wizard"
              aria-selected="false"
            >
              <div class="horizontal-wizard">
                <div class="stroke-icon-wizard"><span>2</span></div>
                <div class="horizontal-wizard-content">
                  <h3>Sheet </h3>
                </div>
              </div> </a
            >
            <!-- <a
              class="nav-link"
              id="inquiry-n-wizard-tab"
              data-bs-toggle="pill"
              href="#inquiry-n-wizard"
              role="tab"
              aria-controls="inquiry-n-wizard"
              aria-selected="false"
            >
              <div class="horizontal-wizard">
                <div class="stroke-icon-wizard"><span>3</span></div>
                <div class="horizontal-wizard-content">
                  <h3>Sheet List</h3>
                </div>
              </div>
            </a> -->
            <a
              class="nav-link"
              id="user-managment-n-wizard-tab"
              data-bs-toggle="pill"
              href="#user-managment-n-wizard"
              role="tab"
              aria-controls="user-managment-n-wizard"
              aria-selected="false"
            >
              <div class="horizontal-wizard">
                <div class="stroke-icon-wizard"><span>4</span></div>
                <div class="horizontal-wizard-content">
                  <h3>Card</h3>
                </div>
              </div>
            </a>
            <a
              class="nav-link"
              id="successful-n-wizard-tab"
              data-bs-toggle="pill"
              href="#successful-n-wizard"
              role="tab"
              aria-controls="successful-n-wizard"
              aria-selected="false"
            >
              <div class="horizontal-wizard">
                <div class="stroke-icon-wizard"><span>5</span></div>
                <div class="horizontal-wizard-content">
                  <h3>Card Variables</h3>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="col-xl-9">
          <div class="tab-content dark-field" id="vertical-n-wizard-tabContent">
            <basicInfo @continue="handleAddModule" />
            <sheetInfo @continue="handleChangeSetup" :moduleId="moduleId" />
            <!-- <cardListInfo @continue="handleCardListInfo" :moduleId="moduleId" /> -->
            <cardInfo @continue="handleCardInfo" :moduleId="moduleId" /> 
            <cardVariable :moduleId="moduleId"  /> 
          </div>
        </div>
      </div>
    </div>
  </Card1>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent, onMounted, watchEffect, watch } from "vue";
import * as bootstrap from "bootstrap";
import apiService from "@/services/apiService";
import { toast } from "vue3-toastify";
import { useRoute } from "vue-router";

const Card1 = defineAsyncComponent(
  () => import("@/components/commen/card/cardData1.vue")
);
const basicInfo = defineAsyncComponent(
  () => import("@/components/theme/admin/workspace-modules/moduleInfo.vue")
);
const sheetInfo = defineAsyncComponent(
  () => import("@/components/theme/admin/workspace-modules/sheetInfo.vue")
);
const cardListInfo = defineAsyncComponent(
  () => import("@/components/theme/admin/workspace-modules/cardListInfo.vue")
);
const cardVariable = defineAsyncComponent(
  () => import("@/components/theme/admin/workspace-modules/cardVariable.vue")
);
const cardInfo = defineAsyncComponent(
  () => import("@/components/theme/admin/workspace-modules/cardInfo.vue")
);

const moduleId = ref();
const route = useRoute();

// set initial value
moduleId.value = route.params.moduleId as string | undefined;

// watch for changes
watch(
  () => route.params.moduleId,
  (newVal) => {
    moduleId.value = newVal as string | undefined;
  },
  { immediate: true } // also runs once on mount
);


function switchToTab(identifier: string | number): boolean {
  let tabLink: HTMLElement | null = null;

  if (typeof identifier === "string") {
    // Switch by tab ID
    tabLink = document.querySelector(`#${identifier}`) as HTMLElement;
  } else if (typeof identifier === "number") {
    // Switch by tab index (0-based)
    const tabLinks = document.querySelectorAll(
      "#vertical-n-wizard-tab .nav-link"
    );
    tabLink = tabLinks[identifier] as HTMLElement;
  }

  if (tabLink && typeof bootstrap !== "undefined" && bootstrap.Tab) {
    try {
      const tab = new bootstrap.Tab(tabLink);
      tab.show();
      return true;
    } catch (error) {
      console.error("Failed to switch tab:", error);
      return false;
    }
  } else {
    console.error(
      `Tab not found or Bootstrap Tab API unavailable. Identifier: ${identifier}`
    );
    return false;
  }
}

async function handleAddModule(data: { description: string }) {
  try {
    // Ensure is_default is always set to true
    const payload = {
      ...data,
      is_default: true
    };
    
    const response = await apiService.post("common/workspace-modules", payload);
    if (response) {
      moduleId.value = response?._id;
      toast.success("module added successfully");
      switchToTab("bank-n-wizard-tab");
    }
  } catch (error) {
    console.error("Error creating module:", error);
    toast.error("Failed to create module");
  }
}

function handleChangeSetup(data: {}) {
  console.log("Received from child:", data);
  switchToTab("inquiry-n-wizard-tab");
}
function handleCardListInfo(data: {}) {
  console.log("Received from child:", data);
  switchToTab("user-managment-n-wizard-tab");
}
function handleCardInfo(data: {}) {
  console.log("Received from child:", data);
  switchToTab("successful-n-wizard-tab");
}
</script>
